/**
 * Blob-download helpers for xlsx exports (Screens 4 & 8). Same pattern the
 * reports downloader uses: read the auth'd response as a blob, honour the
 * server's Content-Disposition filename, and trigger a browser download.
 */

/** Parse the download filename from a Content-Disposition header, if present. */
export function filenameFromDisposition(header: string | null): string | undefined {
  if (!header) return undefined
  // Prefer RFC 5987 filename*=UTF-8''… then fall back to a quoted filename=.
  const star = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(header)
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].replace(/^"|"$/g, '').trim())
    } catch {
      // malformed encoding — fall through to the plain filename
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header)
  return plain?.[1]?.trim()
}

export function triggerBrowserDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
